import { EventDetailsTabEventDto } from '@mark43/cad-api';
import { VStack, Spinner, Text } from '@cad-arc';
import { SectionTitle } from '../../section-title';
import { AssociatedEventCard } from './associated-event-card';

export function AssociatedEventsSection({
    associatedEvents,
    isLoading,
}: {
    associatedEvents: EventDetailsTabEventDto[];
    isLoading: boolean;
}) {
    if (isLoading) {
        return <Spinner />;
    }

    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Associated Events" />
            {associatedEvents.length > 0 ? (
                associatedEvents.map((associatedEvent) => (
                    <AssociatedEventCard
                        key={associatedEvent.eventId}
                        associatedEvent={associatedEvent}
                    />
                ))
            ) : (
                <Text fontSize="sm" color="tertiary">
                    --
                </Text>
            )}
        </VStack>
    );
}
